import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

export const SHIFT_LOGO_URL =
  "https://qlxnmbgtohaiyhbzfvvc.supabase.co/storage/v1/object/public/Logos/Shift%20logo_shft-logo-original.png";

export function ShiftLogo({
  className,
  height = 28,
  linked = false,
}: {
  className?: string;
  height?: number;
  linked?: boolean;
}) {
  const image = (
    <img
      src={SHIFT_LOGO_URL}
      alt="Shift"
      className={cn("h-auto w-auto object-contain", className)}
      style={{ height, width: "auto" }}
    />
  );

  if (linked) {
    return (
      <Link to="/" className="inline-flex shrink-0 transition-opacity hover:opacity-80" aria-label="Shift home">
        {image}
      </Link>
    );
  }

  return image;
}
